import { Box, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import { flexRender, getCoreRowModel, getSortedRowModel, useReactTable, createColumnHelper } from '@tanstack/react-table';
import { useMemo, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import { formatDate } from 'utils/helpers';
import { FORMAT_DATE } from 'constants/common';

const HistoryStatusTable = ({ historyStatus, refetch }) => {
  const [sorting, setSorting] = useState([]);
  const columnHelper = createColumnHelper();

  const columns = useMemo(
    () => [
      columnHelper.accessor('user.username', {
        header: 'Người cập nhật',
        cell: info => <Box textTransform="">{info.renderValue()}</Box>,
      }),
      columnHelper.accessor('user.role', {
        header: 'Vai trò',
        cell: info => <Box textTransform="capitalize">{info.renderValue()}</Box>,
      }),
      columnHelper.accessor('status', {
        header: 'Trạng thái',
        cell: info => <Box textTransform="capitalize">{info.getValue() ? 'bật' : 'tắt'}</Box>,
      }),
      columnHelper.accessor('createdAt', {
        header: 'Ngày cập nhật',
        cell: info => formatDate(info.getValue(), FORMAT_DATE),
      }),
    ],
    [historyStatus]
  );

  const table = useReactTable({
    data: historyStatus || [],
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    debugTable: true,
  });

  return (
    <Table>
      <Thead>
        {table.getHeaderGroups().map(headerGroup => (
          <Tr key={headerGroup.id}>
            {headerGroup.headers.map(header => (
              <Th key={header.id} w="120px">
                {header.isPlaceholder ? null : (
                  <Box cursor={header.column.getCanSort() ? 'pointer' : 'default'} onClick={header.column.getToggleSortingHandler()}>
                    {flexRender(header.column.columnDef.header, header.getContext())}
                    {{
                      asc: ' 🔼',
                      desc: ' 🔽',
                    }[header.column.getIsSorted()] ?? null}
                  </Box>
                )}
              </Th>
            ))}
          </Tr>
        ))}
      </Thead>
      <Tbody>
        {isEmpty(table.getRowModel().rows) ? (
          <Tr>
            <Td textAlign="center" colSpan={6}>
              Không có dữ liệu
            </Td>
          </Tr>
        ) : (
          table.getRowModel().rows.map(row => (
            <Tr key={row.id}>
              {row.getVisibleCells().map(cell => (
                <Td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</Td>
              ))}
            </Tr>
          ))
        )}
      </Tbody>
    </Table>
  );
};

export default HistoryStatusTable;
